module.exports = __webpack_public_path__ + "static/media/avatar-woman-red@2x.5c0e870b.png";